import {http} from './index';
import {SaveAnswerRule, GetAnswerRuleList, IsWorkMapType} from '@types';

//新增或修改自动分配配置
export const saveAnswerRule = (params: SaveAnswerRule) => http.post('/teaching-workbench/answer/rule/save', params);

//自动分配配置列表分页查询
export const getAnswerRuleList = (params: GetAnswerRuleList) => http.get('/teaching-workbench/answer/rule/list', params);

//自动分配配置获取单个
export const getAnswerRuleDetail = (ruleId: number) => http.get(`/teaching-workbench/answer/rule/${ruleId}`);

//获取开启的列表
export const reqQaRulePsListOpen = (params: {projectId: number}) => http.post('/teaching-workbench/qaRulePs/list/open', params);

//获取开启的列表
export const saveQaRulePsListOpen = (params: {projectId: number, openSubjectIds: number[], isWorkMap: IsWorkMapType}) => http.post('/teaching-workbench/qaRulePs/save/open', params);

//根据老师查询
export const getTeacherRuleList = (params: GetAnswerRuleList) => http.post('/teaching-workbench/answer/rule/list-teacher', params);

//删除自动分配器
export const deleteRule = (params: {id:number}) => http.delete('/teaching-workbench/answer/rule/delete', params);
